(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["module--contact-forms"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener('DOMContentLoaded', function() {
    var isFrench = window.location.pathname.startsWith('/fr/');
    var englishBtns = document.querySelectorAll('.btn.english');
    var frenchBtns = document.querySelectorAll('.btn.french');
    var englishHeading = document.querySelector('.heading .english');
    var englishText = document.querySelector('.heading .text.english');
    var frenchHeading = document.querySelector('.heading .french');
    var frenchText = document.querySelector('.heading .text.french');

    if (isFrench) {
      englishBtns.forEach(function(btn) { btn.style.display = 'none'; });
      frenchBtns.forEach(function(btn) { btn.style.display = ''; });
      if (englishHeading) englishHeading.style.display = 'none';
      if (englishText) englishText.style.display = 'none';
      if (frenchHeading) frenchHeading.style.display = '';
      if (frenchText) frenchText.style.display = '';
    } else {
      frenchBtns.forEach(function(btn) { btn.style.display = 'none'; });
      englishBtns.forEach(function(btn) { btn.style.display = ''; });
      if (frenchHeading) frenchHeading.style.display = 'none';
      if (frenchText) frenchText.style.display = 'none';
      if (englishHeading) englishHeading.style.display = '';
      if (englishText) englishText.style.display = '';
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    const buttons = document.querySelectorAll('.buttons-wrapper button');
    const forms = document.querySelectorAll('.forms-wrapper .form');
    const formsAnchor = document.getElementById('forms-anchor');

    buttons.forEach(button => {
      button.addEventListener('click', function() {
        const formId = button.getAttribute('data-form-id');

        forms.forEach(form => {
          if (form.getAttribute('data-form-id') === formId) {
            form.style.display = 'block';
          } else {
            form.style.display = 'none';
          }
        });

        // Scroll to #forms-anchor at 768px media size
        if (window.innerWidth <= 768) {
          formsAnchor.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
  });




  } catch(e) { console.error(e); }
})();
})();
